import Vue from "vue";
import VueRouter from "vue-router";


// styles
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@/assets/styles/tailwind.css";

// mouting point for the whole app

import App from "@/App.vue";
// views without layouts


// Pages View
import Index from "@/views/Token.vue";
import NFTbonds from "@/views/NFTbonds.vue";
import Overview from "@/views/Overview.vue";
import Reservations from "@/views/Reservations.vue";
import FAQ from "@/views/FAQ.vue";
import dApp from "@/views/dapp.vue";
import BountyLottery from "@/views/BountyLottery.vue";

// Staking Dashboard View
import Staking from "@/views/staking/Staking.vue";
import InsuranceStaking from "@/views/staking/InsuranceStaking.vue";
import CollateralStaking from "@/views/staking/CollateralStaking.vue";
import BulkStaking from "@/views/staking/BulkStaking.vue";
import Governance from "@/views/staking/Governance.vue";
import StakingPools from "@/views/staking/StakingPools.vue";
import ReferralStatus from "@/views/staking/ReferralStatus.vue";
import ReferralLink from "@/views/staking/ReferralLink.vue";
import Swap from "@/views/staking/Swap.vue";
import OnRamp from "@/views/staking/OnRamp.vue";

// NFT Marketplace Dashboard View
import NFTMarketplace from "@/views/NFTMarketplace/NFTMarketplace.vue";
import BGBBNFTMarketplace from "@/views/NFTMarketplace/BGBBNFTMarketplace.vue";
import MyNFTs from "@/views/NFTMarketplace/MyNFTs.vue";
import MyBGBBNFTs from "@/views/NFTMarketplace/MyBGBBNFTs.vue";
import MintNFT from "@/views/NFTMarketplace/MintNFT.vue";
import SellNFTs from "@/views/NFTMarketplace/SellNFTs.vue";

// Global Templates
import Admin from "@/layouts/Admin.vue";
import Marketplace from "@/layouts/Marketplace.vue";


import * as THREE from 'three'
// eslint-disable-next-line no-unused-vars
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene();

// Loader
var loader = new THREE.BufferGeometryLoader();

const settings = {
  metalness: 0,
  roughness: 0,
  normalScale: 1
};

const material = new THREE.MeshStandardMaterial( {
  color: 0xe8bb42,
  roughness: settings.roughness,
  metalness: settings.metalness,
  normalScale: new THREE.Vector2( 1, - 1 ), // why does the normal map require negation in this case?
  // emissive: 0xe8bb42,
  // emissiveIntensity:0,
  side: THREE.DoubleSide

} );
var model;
loader.load('static/geometry.json', geometry => {
  model = new THREE.Mesh(geometry, material);
  model.position.set(0.85,0.05,0);
  model.scale.set(0.00062,0.00062,0.00062); 



  if(window.innerWidth < 600){
    model.position.set(0.6,0.42,0);
    model.scale.set(0.00062,0.00062,0.00062); 
  }
  if(window.innerHeight > 900){
    model.position.set(0.6,0.13,0);
    model.scale.set(0.00062,0.00062,0.00062); 
  }
  if(window.innerHeight > 1100){
    model.position.set(0.6,0.25,0);
    model.scale.set(0.00062,0.00062,0.00062); 
  }
  scene.add(model);
});

var light = new THREE.HemisphereLight(0x404040, 0xFFFFFF, 1.2);
scene.add(light);

const sizes = {
  width: window.innerWidth,
  height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth;
    sizes.height = window.innerHeight;

    // Update camera
    camera.aspect = sizes.width / sizes.height;
    camera.updateProjectionMatrix();

    // Update renderer
    renderer.setSize(sizes.width, sizes.height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
})

const camera = new THREE.PerspectiveCamera(50, sizes.width / sizes.height, 0.1, 100);
camera.position.x = 0;
camera.position.y = 0;
camera.position.z = 2;
// camera.lookAt( 0, 0, 0 );
scene.add(camera);


const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
  alpha: true
})
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    
document.addEventListener('mousemove', onDocumentMouseMove);

let mouseX = 0;
let mouseY = 0;

// eslint-disable-next-line no-unused-vars
let targetX = 0;

// eslint-disable-next-line no-unused-vars
let targetY = 0;


const windowX = window.innerWidth / 2;
const windowY = window.innerHeight / 2;

var mouseDown = false;

function onMouseDown(evt) {
    evt.preventDefault();

    mouseDown = true;
    // mouseX = evt.clientX;
    // mouseY = evt.clientY;
}

function onMouseUp(evt) {
    evt.preventDefault();

    mouseDown = false;
}

document.addEventListener('mousedown', function (e) {
    onMouseDown(e);
}, false);
document.addEventListener('mouseup', function (e) {
    onMouseUp(e);
}, false);

// eslint-disable-next-line no-unused-vars
function onDocumentMouseMove(event){
  if (!mouseDown) {
      return;
  }
  event.preventDefault();

  mouseX = (event.clientX - windowX)
  mouseY = (event.clientY - windowY)
}


// eslint-disable-next-line no-unused-vars
const updateSphere = (event) => {  
    if (model && window.innerWidth < 600) {
        model.position.z = window.scrollY * 0.009;
    }else{
      camera.rotation.y = window.scrollY * 0.002;
      model.position.z = window.scrollY * 0.001;
    }
}
window.addEventListener('load', function(){
  
  var touchsurface = document.getElementById('canv'),
      mouseX,
      mouseY,
      dist,
      threshold = 150, //required min distance traveled to be considered swipe
      allowedTime = 200, // maximum time allowed to travel that distance
      elapsedTime,
      startTime

  function handleswipe(isrightswipe){
      if (isrightswipe)
          touchsurface.innerHTML = 'Congrats, you\'ve made a <span style="color:red">right swipe!</span>'
      else{
          touchsurface.innerHTML = 'Condition for right swipe not met yet'
      }
  }

  touchsurface.addEventListener('touchstart', function(e){
      touchsurface.innerHTML = ''
      var touchobj = e.changedTouches[0]
      dist = 0
      mouseX = touchobj.pageX
      mouseY = touchobj.pageY
      startTime = new Date().getTime() // record time when finger first makes contact with surface
      e.preventDefault()
  }, false)

  touchsurface.addEventListener('touchmove', function(e){
      e.preventDefault() // prevent scrolling when inside DIV
  }, false)

  touchsurface.addEventListener('touchend', function(e){
      var touchobj = e.changedTouches[0]
      dist = touchobj.pageX - mouseX // get total dist traveled by finger while in contact with surface
      elapsedTime = new Date().getTime() - startTime // get time elapsed
      // check that elapsed time is within specified, horizontal dist traveled >= threshold, and vertical dist traveled <= 100
      var swiperightBol = (elapsedTime <= allowedTime && dist >= threshold && Math.abs(touchobj.pageY - mouseY) <= 100)
      handleswipe(swiperightBol)
      e.preventDefault()
  }, false)

}, false) // end window.onload

window.addEventListener('scroll', updateSphere);

const clock = new THREE.Clock();


const tick = () =>
{   
  
    targetX = mouseX * .009;
    targetY = mouseY * .001;

    // eslint-disable-next-line no-unused-vars
    const elapsedTime = clock.getElapsedTime()
    renderer.render(scene, camera);
   
    if (model) {
      model.rotation.y = 1.5 * elapsedTime
      model.rotation.y += .5 * (targetX - model.rotation.y)
    }

      // Call tick again on the next frame
      window.requestAnimationFrame(tick);
  }
  
tick()
// routes

const routes = [
  




//  STAKING URLS

  {
    path: "/admin",
    redirect: "/dashboard",
    component: Admin,
    children: [
      {
        path: "/staking",
        component: Staking,
      },
      {
        path: "/insurance-staking",
        component: InsuranceStaking,
      },
      {
        path: "/collateral-staking",
        component: CollateralStaking,
      },
      {
        path: "/bulk-staking",
        component: BulkStaking,
      },


      {
        path: "/governance",
        component: Governance,
      },


      {
        path: "/referral-status",
        component: ReferralStatus,
      },


      {
        path: "/staking-pools",
        component: StakingPools,
      },

      {
        path: "/referral-link",
        component: ReferralLink,
      },

      {
        path: "/swap",
        component: Swap,
      },


      {
        path: "/on-ramp-exchange",
        component: OnRamp,
      },


    ],
  },


//  NFT URLS


  {
    path: "/NFTMarketplace",
    redirect: "/NFTMarketplace",
    component: Marketplace,
    children: [
      {
        path: "/NFT-marketplace",
        component: NFTMarketplace,
      },
      {
        path: "/BGBB-NFT-marketplace",
        component: BGBBNFTMarketplace,
      },

      {
        path: "/my-nfts",
        component: MyNFTs,
      },

      {
        path: "/my-bgbb-nfts",
        component: MyBGBBNFTs,
      },

      {
        path: "/mint-nft",
        component: MintNFT,
      },


      {
        path: "/sell-nfts",
        component: SellNFTs,
      },



    ],
  },



  



  // {
  //   path: "/NFTMarketplace",
  //   name: "NFTMarketplace",
  //   component: NFTMarketplace,
  //   meta: {
  //     auth: false,
  //     title: 'NFTMarketplace'
  //   }
  // },


//  PAGES URLS



  {
    path: "/NFTbonds",
    name: "NFTbonds",
    component: NFTbonds,
    meta: {
      auth: false,
      title: 'NFTbonds'
    }
  },


  {
    path: "/bounty-and-lottery",
    name: "BountyLottery",
    component: BountyLottery,
    meta: {
      auth: false,
      title: 'BountyLottery'
    }
  },





  {
    path: "/FAQ",
    name: "FAQ",
    component: FAQ,
    meta: {
      auth: false,
      title: 'FAQ'
    }
  },



  {
    path: "/dApp",
    name: "dApp",
    component: dApp,
    meta: {
      auth: false,
      title: 'dApp'
    }
  },




  

  {
    path: "/",
    name: "Reservations",
    component: Reservations,
    meta: {
      auth: false,
      title: 'Reservations'
    }
  },




  {
    path: "/overview",
    name: "Overview",
    component: Overview,
    meta: {
      auth: false,
      title: 'Overview'
    }
  },





  {
    path: "/token",
    component: Index,
    name: "BGBB Token",
     meta: {
      auth: false,
      title: 'BGBB.io | Fixed APR Utility NFTs'
    }
  },
  { path: "*", redirect: "/" },
];

// app config

Vue.config.productionTip = false;

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  history: false,
  routes,
});

router.afterEach((to) => {
  if(to.meta && to.meta.title) {
    document.title = to.meta.title + ' | BGBB.io';
  }
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
